import { render, staticRenderFns } from "./dwsPreview.vue?vue&type=template&id=57ad89ad&scoped=true&"
import script from "./dwsPreview.vue?vue&type=script&lang=js&"
export * from "./dwsPreview.vue?vue&type=script&lang=js&"
import style0 from "./dwsPreview.vue?vue&type=style&index=0&id=57ad89ad&scoped=true&lang=less&"
import style1 from "./dwsPreview.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad89ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ad89ad')) {
      api.createRecord('57ad89ad', component.options)
    } else {
      api.reload('57ad89ad', component.options)
    }
    module.hot.accept("./dwsPreview.vue?vue&type=template&id=57ad89ad&scoped=true&", function () {
      api.rerender('57ad89ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/preview/dwsPreview.vue"
export default component.exports